export const ITEM_LIST = {
    UNITS: "units",
    ITEMS: "ITEMS",
    EXCEEDED: "EXCEEDED",
    ITEMS_LIMIT: 5,
};

export const TEST_ID_PLACEHOLDER = "{0}-{1}";

export enum CLICKED_CTA {
    PRIMARY = "PRIMARY",
    SECONDARY = "SECONDARY",
}
